/**
 * 数字资产 V1
 * - Tab: 角色 / 场景 / 道具 / 运镜库 / 音色 / BGM
 * - 角色 / 场景 / 道具:AssetListPanel(可新建 + 多视图设定图生成)
 * - 运镜库:CameraMovePanel
 * - 音色 / BGM:ComingSoonPanel(功能开发中)
 */
import { useState } from 'react';
import { Users, Map, Package, Mic2, Music2, Video } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { AssetListPanel } from './AssetListPanel';
import { CameraMovePanel } from './CameraMovePanel';
import { ComingSoonPanel } from './ComingSoonPanel';
import type { BrainKind } from './types';

const TABS: { id: BrainKind; label: string; icon: typeof Users }[] = [
  { id: 'character', label: '角色', icon: Users },
  { id: 'location', label: '场景', icon: Map },
  { id: 'camera_move', label: '运镜库', icon: Video },
  { id: 'prop', label: '道具', icon: Package },
  { id: 'voice', label: '音色', icon: Mic2 },
  { id: 'bgm', label: 'BGM', icon: Music2 },
];

export function BrainPage() {
  const [tab, setTab] = useState<BrainKind>('character');

  return (
    <div className="space-y-5 p-6 lg:p-8">
      <header>
        <h1 className="text-3xl font-semibold tracking-tight">数字资产</h1>
        <p className="mt-1 text-sm text-neutral-600">
          角色 / 场景 / 道具设定 · 多视图 AI 生成 · 跨剧集复用
        </p>
      </header>

      <Tabs value={tab} onValueChange={(v) => setTab(v as BrainKind)} className="space-y-4">
        <TabsList className="h-10">
          {TABS.map((t) => (
            <TabsTrigger key={t.id} value={t.id} className="gap-1.5">
              <t.icon className="h-4 w-4" />
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="character">
          <AssetListPanel kind="character" />
        </TabsContent>
        <TabsContent value="location">
          <AssetListPanel kind="location" />
        </TabsContent>
        <TabsContent value="camera_move">
          <CameraMovePanel />
        </TabsContent>
        <TabsContent value="prop">
          <AssetListPanel kind="prop" />
        </TabsContent>
        <TabsContent value="voice">
          <ComingSoonPanel
            name="音色"
            description="将接入 GPT-SoVITS / 自训音色库,绑定到角色后自动驱动对白合成。"
          />
        </TabsContent>
        <TabsContent value="bgm">
          <ComingSoonPanel
            name="BGM"
            description="将提供按情绪 / 题材匹配的 BGM 库与一键替换功能。"
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
